/*引用vue和vuex*/
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

/*设置state参数*/
const state = {
  img_num: 0
};
// 操作数据
const mutations = {
  setImgNum(state, num) {
      state.img_num = num;
    }
};
//
const getters = {
  showHeader: state => state.showHeader,
};
//
const actions = {
  updateValue({ commit }, payload) {
      commit('setValue', payload);
    }
};
const store = new Vuex.Store({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage
      // reducer(val){
      //   return {
      //     assessmentData: val.assessmentData
      //   }
      // }
    })
  ]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js